import 'react-multi-carousel/lib/styles.css';
import * as React from 'react';
import ComprehensiveSearch from '../components/comprehensiveSearch/ComprehensiveSearch';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import ProductChat from '../components/product/ProductChat';
import ProductHeader from "components/product/ProductHeader";
import ProgressBar from 'components/atomic/ProgressBar';

import { xVerifyService } from 'services';
import { checkEmail } from '../helpers/emailChecker';
import { usePrevious } from '../hooks';
import { NextSeo } from 'next-seo';
import { config } from '_config';
const { apiUrl } = config;

const steps = ["Step 1", "Step 2", "Step 3", "Step 4" ];

export default function ComprehensiveSearchReport() {
  const router = useRouter();
  const rightSide = useRef();

  const orderSearch = [
    {
      code: 'TRADEMARK_Trademark_Search_Federal_State',
      desc: 'Provides any similar names, logos, or slogans that are registered or pending with the USPTO or any of the 50 states',
      popular: true,
      recommended: false,
    },
    {
      code: 'TRADEMARK_Trademark_Search_Common_Law',
      desc: 'Same as above, but also includes a proprietary search of corporate directories, common law and domain names',
      popular: false,
      recommended: true,
    },
    {
      code: 'TRADEMARK_Trademark_Search_Global',
      desc: 'Same as above, but also includes searches for pending and registered marks in these multi-national jurisdictions: i. THe European community; and (ii) the World Intellectual Property Organiztion (WIPO)',
      popular: false,
      recommended: false,
    },
  ];
  const [searchProductList, setSearchProductList] = useState(null);
  const [trademarkRushProcessing, setTrademarkRushProcessing] = useState({
    code: 'TRADEMARK_Trademark_Rush_Processing',
  });
  useEffect(() => {
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );
    let url = apiUrl + '/category/TRADEMARKS/products/prices';
    let fallbackUrl =
      `${salePageURL}/crm` + '/category/TRADEMARKS/products/prices';

    axios
      .get(url, {
        params: { onlyForSale: false, processingOptions: 'STANDARD' },
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200) {
          response.data
            .filter((product) => product.code.code.includes('Search'))
            .forEach((searchProduct) => {
              for (const element of orderSearch) {
                if (element.code === searchProduct.code.code) {
                  element.price = searchProduct.price;
                  element.customerName = searchProduct.code.customerName;
                }
              }
            });
          setSearchProductList(orderSearch);
          response.data
            .filter((product) =>
              product.code.code.includes('TRADEMARK_Trademark_Rush_Processing')
            )
            .forEach((rushTrademark) => {
              trademarkRushProcessing.price = rushTrademark.price;
              trademarkRushProcessing.customerName =
                rushTrademark.code.customerName;
              setTrademarkRushProcessing(trademarkRushProcessing);
            });
          const product = JSON.parse(localStorage.getItem('product'));
          const historyPath = localStorage.getItem('path');
          if (
            historyPath &&
            historyPath === 'comprehensive-search-report' &&
            product
          ) {
            window.scrollTo(0, 0);
            setState({ ...product });
          }
        }
      })
      .catch((error) => {
        if (error.request) {
          axios
            .get(fallbackUrl, {
              params: { onlyForSale: false, processingOptions: 'STANDARD' },
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
              if (response.status === 200) {
                response.data
                  .filter((product) => product.code.code.includes('Search'))
                  .forEach((searchProduct) => {
                    for (const element of orderSearch) {
                      if (element.code === searchProduct.code.code) {
                        element.price = searchProduct.price;
                        element.customerName = searchProduct.code.customerName;
                      }
                    }
                  });
                setSearchProductList(orderSearch);
                response.data
                  .filter((product) =>
                    product.code.code.includes(
                      'TRADEMARK_Trademark_Rush_Processing'
                    )
                  )
                  .forEach((rushTrademark) => {
                    trademarkRushProcessing.price = rushTrademark.price;
                    trademarkRushProcessing.customerName =
                      rushTrademark.code.customerName;
                    setTrademarkRushProcessing(trademarkRushProcessing);
                  });
                const product = JSON.parse(localStorage.getItem('product'));
                const historyPath = localStorage.getItem('path');
                if (
                  historyPath &&
                  historyPath === 'comprehensive-search-report' &&
                  product
                ) {
                  window.scrollTo(0, 0);
                  setState({ ...product });
                }
              }
            });
        }
      });
  }, []);

  const [state, setState] = React.useState({
    code: 'TRADEMARK',
    trademarkType: 'NAME',
    markDesc: null,
    literalElements: null,
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    searchType: 'TRADEMARK_Trademark_Search_Federal_State',
    trademarkRushType: 'TRADEMARK_Trademark_Rush_Processing',
    rushProcessing: true,
    verifying: false,
    verificationResult: {},
    step: 0,
  });

  const prevState = usePrevious(state);

  const verifyEmail = useCallback(() => {
    if (!state.verificationResult?.email && checkEmail(state.email)) {
      setState((prevState) => ({ ...prevState, verifying: true }));

      xVerifyService.verifyEmail(state.email).then((result) => {
        setState((prevState) => {
          return {
            ...prevState,
            verificationResult: {
              ...prevState.verificationResult,
              email: result,
            },
            verifying: false,
          };
        });
      });
    }
  }, [state]);

  const handleBlur = useCallback(
    (e) => {
      const { type } = e.target;
      if (type === 'email') {
        verifyEmail();
      }
    },
    [verifyEmail]
  );

  function handleChange(e) {
    if (e.target.name) {
      if (e.target.name === 'rushProcessing') {
        setState({ ...state, [e.target.name]: e.target.checked });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.name]: e.target.checked })
        );
      } else {
        if (e.target.type === 'email') {
          setState({
            ...state,
            [e.target.name]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.name]: null,
            },
          });
          localStorage.setItem(
            'product',
            JSON.stringify({
              ...state,
              [e.target.name]: e.target.value,
              verificationResult: {
                ...state.verificationResult,
                [e.target.name]: null,
              },
            })
          );
        } else {
          setState({ ...state, [e.target.name]: e.target.value });
          localStorage.setItem(
            'product',
            JSON.stringify({ ...state, [e.target.name]: e.target.value })
          );
        }
      }
    } else {
      if (e.target.type === 'email') {
        setState({
          ...state,
          [e.target.id]: e.target.value,
          verificationResult: {
            ...state.verificationResult,
            [e.target.id]: null,
          },
        });
        localStorage.setItem(
          'product',
          JSON.stringify({
            ...state,
            [e.target.id]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.id]: null,
            },
          })
        );
      } else {
        setState({ ...state, [e.target.id]: e.target.value });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.id]: e.target.value })
        );
      }
    }
    localStorage.setItem('path', 'comprehensive-search-report');
  }

  function handleStep(value) {
    setState({ ...state, step: value });
    localStorage.setItem('product', JSON.stringify({ ...state, step: value }));
    localStorage.setItem('path', 'comprehensive-search-report');
    router.push('/comprehensive-search-report?step=' + value, undefined, {
      shallow: true,
    });
  }

  useEffect(() => {
    if (prevState?.email === null) {
      verifyEmail();
    }
  }, [prevState, verifyEmail]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      rightSide.current?.scrollIntoView();
    });

    return () => {
      clearTimeout(timeout);
    };
  }, [rightSide.current]);

  useEffect(() => {
    let timeout;

    function handleRouteChangeComplete() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      });
    }

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      clearTimeout(timeout);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);

  return (
    <div className="reg" ref={config.skin === 'v2-basic' ? rightSide : null}>
      <NextSeo title="Comprehensive Trademark Search" />
      {config.skin === 'v2-basic' && (
        <div className="filing-banner-outer-container">
          <div className="filing-banner-inner-container">
            <ProductHeader header="Comprehensive Search Report Questionnaire" />
            <ProgressBar value={state.step + 1} maxValue={steps.length} />
          </div>
        </div>
      )}
      <div className="side-wrapper">
        <div className="left-side">
          <div className="banner">
            <div className="summary">
              <h3>Comprehensive Search Summary</h3>
              <div className="step-box">
                <h5 style={{ textTransform: 'uppercase' }}>
                  TRADEMARK {state.trademarkType}
                </h5>
                {state.markDesc ? <p>{state.markDesc}</p> : ''}
                {state.trademarkType === 'LOGO' ? (
                  <p>{state.literalElements}</p>
                ) : (
                  ''
                )}
              </div>
              {state.step > 0 ? (
                <div className="step-box">
                  <h5>Contact Information</h5>
                  <p>
                    {state.firstName ? state.firstName : ''}{' '}
                    {state.lastName ? state.lastName : ''}
                  </p>
                  <p>
                    {state.phone ? state.phone : ''}{' '}
                    {state.email ? state.email : ''}
                  </p>
                </div>
              ) : null}
              {state.step > 1 ? (
                <div className="step-box">
                  <h5>SEARCH PACKAGE</h5>
                  <p>
                    {searchProductList
                      ? searchProductList.filter(
                          (searchProduct) =>
                            searchProduct.code === state.searchType
                        )[0].customerName
                      : ''}
                  </p>
                </div>
              ) : null}
              {state.step > 2 && state.rushProcessing ? (
                <div className="step-box">
                  <h5>THE PROCESSING SPEED</h5>
                  <p>
                    Rush Priority Processing. Next day processing, when you need
                    your search fast.
                  </p>
                </div>
              ) : null}
              <ProductChat />
            </div>
          </div>
        </div>
        <div className="right-side" id="rightSide" ref={config.skin === 'v2-basic' ? null : rightSide}>
          <div className="form">
            <ComprehensiveSearch
              state={state}
              onChange={handleChange}
              onBlur={handleBlur}
              onStep={handleStep}
              searchProductList={searchProductList}
              trademarkRushProcessing={trademarkRushProcessing}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
